import { X } from "lucide-react";
import { useIntl } from "react-intl";

import { Button } from "../../../../../atoms/button";
import { useDataFormPreferencesContext } from "../../context";

export function DataFormPreferencesToolbarCancelButton() {
  const intl = useIntl();

  const { setMode } = useDataFormPreferencesContext();

  return (
    <Button
      variant="base"
      iconLeft={{ Icon: X }}
      onClick={() => setMode("detail")}
    >
      {intl.formatMessage({
        id: "data-form-preferences.cancel",
        defaultMessage: "Zrušit",
      })}
    </Button>
  );
}
